import React from "react";
import { Hammer, Ruler, Settings, Wrench, ShieldCheck } from "lucide-react";

const ICONS = { hammer: Hammer, ruler: Ruler, settings: Settings, wrench: Wrench };

/**
 * Four-up specification strip.
 * Values are derived by the backend from the page's own copy (materials,
 * fitment evidence, winch/lighting mentions) - nothing is invented here.
 */
export default function SpecStrip({ highlights = [] }) {
  if (highlights.length < 2) return null;
  return (
    <div
      className="grid grid-cols-1 divide-y rounded-xl border sm:grid-cols-2 sm:divide-y-0 lg:grid-cols-4"
      style={{ borderColor: "rgba(255,255,255,0.09)", background: "var(--nq-ink)" }}
      data-testid="spec-strip"
    >
      {highlights.map((h, i) => {
        const Icon = ICONS[h.icon] || ShieldCheck;
        return (
          <div
            key={h.label}
            className={`flex gap-3 p-4 md:p-5 ${i > 0 ? "lg:border-l" : ""} ${i % 2 === 1 ? "sm:border-l" : ""}`}
            style={{ borderColor: "rgba(255,255,255,0.09)" }}
            data-testid="spec-strip-item"
          >
            <Icon className="mt-0.5 h-5 w-5 shrink-0 green-text" />
            <div className="min-w-0">
              <p className="text-[10px] font-semibold uppercase tracking-[0.16em] green-text">{h.label}</p>
              <p className="mt-1 text-sm font-semibold leading-snug text-[color:var(--nq-sand)]">{h.value}</p>
              {h.note && (
                <p className="mt-1 text-xs leading-snug text-[color:var(--nq-stone)]">{h.note}</p>
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
}
